import React, { useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { EventCard } from '../components/shared/EventCard';
import { Button } from '../components/ui/Button';
import { motion } from 'framer-motion';
import { Calendar, Filter } from 'lucide-react';
const allEvents = [{
  title: 'Sunday Worship Service',
  time: '10:00 AM - 12:00 PM EST',
  location: 'The Household Church, Largo MD',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '09',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'worship'
}, {
  title: 'Impact Wednesday Service',
  time: '7:00 - 9:00 PM EST',
  location: 'The Household Church, Largo MD',
  image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '12',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'worship'
}, {
  title: 'Deep Dive (Bible Study)',
  time: '9:00 - 10:00 AM EST',
  location: 'The Household Church, Largo MD',
  image: 'https://images.unsplash.com/photo-1494783367193-149034c05e8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '16',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'study'
}, {
  title: 'Youth Ministry Gathering',
  time: '6:30 - 8:30 PM EST',
  location: 'Youth Hall',
  image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '17',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'youth'
}, {
  title: 'Prayer Line',
  time: '12:00 - 12:30 PM EST',
  location: 'Online via Phone',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '18',
  month: 'FEB',
  eventType: 'online' as const,
  category: 'prayer'
}, {
  title: 'Impact Wednesday Service',
  time: '7:00 - 9:00 PM EST',
  location: 'The Household Church, Largo MD',
  image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '19',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'worship'
}, {
  title: "Women's Fellowship",
  time: '10:00 AM - 12:00 PM EST',
  location: 'Fellowship Hall',
  image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '22',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'fellowship'
}, {
  title: 'Sunday Worship Service',
  time: '10:00 AM - 12:00 PM EST',
  location: 'The Household Church, Largo MD',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '23',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'worship'
}, {
  title: 'Community Outreach',
  time: '9:00 AM - 1:00 PM EST',
  location: 'Local Community Center',
  image: 'https://images.unsplash.com/photo-1593113580332-8288e4e46084?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  day: '28',
  month: 'FEB',
  eventType: 'in-person' as const,
  category: 'outreach'
}];
const categories = [{
  id: 'all',
  label: 'All Events'
}, {
  id: 'worship',
  label: 'Worship'
}, {
  id: 'prayer',
  label: 'Prayer'
}, {
  id: 'study',
  label: 'Bible Study'
}, {
  id: 'youth',
  label: 'Youth'
}, {
  id: 'fellowship',
  label: 'Fellowship'
}, {
  id: 'outreach',
  label: 'Outreach'
}];
export function EventsPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [eventTypeFilter, setEventTypeFilter] = useState<'all' | 'in-person' | 'online'>('all');
  const filteredEvents = allEvents.filter(event => {
    const categoryMatch = activeFilter === 'all' || event.category === activeFilter;
    const typeMatch = eventTypeFilter === 'all' || event.eventType === eventTypeFilter;
    return categoryMatch && typeMatch;
  });
  return <Layout data-id="element-509">
      {/* Hero Section */}
      <section className="relative pt-44 md:pt-48 pb-20 bg-[#0A1F44] overflow-hidden" data-id="element-510">
        <div className="absolute inset-0 opacity-20" data-id="element-511">
          <img src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Events background" className="w-full h-full object-cover" data-id="element-512" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44]/80 to-[#0A1F44]" data-id="element-513" />

        <div className="container-custom relative z-10" data-id="element-514">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center" data-id="element-515">
            <Calendar className="w-12 h-12 text-[#C8102E] mx-auto mb-6" data-id="element-516" />
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-517">
              Upcoming Events
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-518">
              Join us for worship, fellowship, and community. There's always
              something happening at The Household.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 bg-white border-b sticky top-16 z-30" data-id="element-519">
        <div className="container-custom" data-id="element-520">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-521">
            {/* Category Filters */}
            <div className="flex flex-wrap gap-2" data-id="element-522">
              {categories.map(category => <button key={category.id} onClick={() => setActiveFilter(category.id)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeFilter === category.id ? 'bg-[#0A1F44] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-523">
                  {category.label}
                </button>)}
            </div>

            {/* Event Type Filter */}
            <div className="flex items-center gap-2" data-id="element-524">
              <Filter className="w-4 h-4 text-gray-400" data-id="element-525" />
              <select value={eventTypeFilter} onChange={e => setEventTypeFilter(e.target.value as 'all' | 'in-person' | 'online')} className="px-3 py-2 bg-gray-100 border-none rounded-lg text-sm font-medium text-gray-600 focus:outline-none focus:ring-2 focus:ring-[#0A1F44]" data-id="element-526">
                <option value="all" data-id="element-527">All Types</option>
                <option value="in-person" data-id="element-528">In Person</option>
                <option value="online" data-id="element-529">Online</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="py-16 bg-[#F5F7FA] min-h-[500px]" data-id="element-530">
        <div className="container-custom" data-id="element-531">
          {filteredEvents.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-532">
              {filteredEvents.map((event, index) => <EventCard key={index} title={event.title} time={event.time} location={event.location} image={event.image} day={event.day} month={event.month} eventType={event.eventType} data-id="element-533" />)}
            </div> : <div className="text-center py-20" data-id="element-534">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-535">
                <Calendar className="w-8 h-8 text-gray-400" data-id="element-536" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-537">
                No events found
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-538">
                We couldn't find any events matching your current filters.
              </p>
              <Button variant="outline" onClick={() => {
            setActiveFilter('all');
            setEventTypeFilter('all');
          }} data-id="element-539">
                Clear Filters
              </Button>
            </div>}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white" data-id="element-540">
        <div className="container-custom" data-id="element-541">
          <div className="bg-gradient-to-r from-[#0A1F44] to-[#163A70] rounded-2xl p-8 md:p-12 text-center" data-id="element-542">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4" data-id="element-543">
              Want to Host an Event?
            </h2>
            <p className="text-white/80 mb-8 max-w-xl mx-auto" data-id="element-544">
              Have an idea for a community event or ministry gathering? We'd
              love to hear from you and help make it happen.
            </p>
            <Button className="bg-[#C8102E] hover:bg-[#A00D24] text-white border-none" size="lg" data-id="element-545">
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </Layout>;
}